import type { LoaderFunctionArgs } from "@remix-run/node"

import * as UI from "@iyk/ui"

import { json, redirect } from "@remix-run/node"
import { useLoaderData } from "@remix-run/react"
import { checkIYKUser } from "../lib/auth.server.ts"
import { LoginForm } from "../lib/ui/login-form.tsx"
import { getSafeRedirectTo } from "../lib/utils/url.server.ts"

export async function loader(args: LoaderFunctionArgs) {
  const user = await checkIYKUser(args)
  if (user) {
    throw redirect("/profile")
  }

  const theme = new URL(args.request.url).searchParams.get("theme")
  return json({ redirectTo: getSafeRedirectTo(args.request.url, "/profile"), theme })
}

export default function Login() {
  const { redirectTo } = useLoaderData<typeof loader>()

  return (
    <div className="min-h-dvh flex flex-col justify-center items-center">
      <div className="fixed top-4 left-4">
        <UI.Icon.IykLogo className="size-7" />
      </div>
      <div className="sm:max-w-96 w-full mx-auto flex flex-col gap-6 p-4">
        <LoginForm redirectTo={redirectTo} />
      </div>
    </div>
  )
}
